import styled from '@emotion/styled'
import { useRef } from 'react'

const Iframe = styled.iframe`
  aspect-ratio: 16 / 9;
  width: 100%;
  border: 0;
  outline: 0;
  border-radius: var(--border-radius-tiniest);
`

export const ExtranetVideoPlayer = ({ playerUri, title }: { playerUri: string; title: string }) => {
  const playerRef = useRef<HTMLIFrameElement | null>(null)
  /* 
  useEffect(() => {
    if (playerRef && playerRef.current) {
      const player = new Player(playerRef.current)

      if (player && (player as any).setColo
type SetColorsFn = (colors: string[]) => Promise<string[]>rs) {
        // @types/vimeo__player package is flawed, and does not contain type declaration for Player.setColors() fn
        // so we have to use this stupid trick
        const setColors = (player as any).setColors as SetColorsFn

        setColors(['#88288f', '#ffffff', '#ffffff', '#333333'])
      }
    }
  }, [playerRef?.current]) */

  return (
    <>
      <Iframe
        src={playerUri}
        title={title}
        allowFullScreen
        allow="fullscreen; picture-on-picture; autoplay;"
        ref={playerRef}
      />
    </>
  )
}
